import {
  Overlay,
  ScrollStrategyOptions,
  OverlayKeyboardDispatcher,
  OverlayPositionBuilder,
  OverlayOutsideClickDispatcher,
} from '@angular/cdk/overlay';
import { Location } from '@angular/common';
import { ComponentFactoryResolver, Injectable, Injector, NgZone, Optional } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';
import { DynamicOverlayContainer } from '@core/modules/dynamic-overlay/dynamic-overlay-container';
import { Platform } from '@angular/cdk/platform';

@Injectable()
export class DynamicOverlay extends Overlay {
  private dynamicOverlayContainer: DynamicOverlayContainer;

  constructor(
    scrollStrategies: ScrollStrategyOptions,
    overlayContainer: DynamicOverlayContainer,
    componentFactoryResolver: ComponentFactoryResolver,
    positionBuilder: OverlayPositionBuilder,
    keyboardDispatcher: OverlayKeyboardDispatcher,
    injector: Injector,
    ngZone: NgZone,
    directionality: Directionality,
    @Optional() location: Location,
  ) {
    super(
      scrollStrategies,
      overlayContainer,
      componentFactoryResolver,
      positionBuilder,
      keyboardDispatcher,
      injector,
      ngZone,
      document,
      directionality,
      location,
      new OverlayOutsideClickDispatcher(document, new Platform({})),
    );

    this.dynamicOverlayContainer = overlayContainer;
  }

  public setContainerElement(containerElement: HTMLElement): void {
    this.dynamicOverlayContainer.setContainerElement(containerElement);
  }
}
